var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"create-other-profile"},[_c('div',{staticClass:"background"}),_c('div',{staticClass:"create-other-profile__form"},[_c('h2',{staticClass:"create-other-profile__title page-title"},[_vm._v("Create Profile")]),_c(_setup.OnboardingForm,{attrs:{"add-to-existing":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }